import {
    CHANGE_HOMETAB, BILL_CHOICE, SEND_OTP_SUCCESS, HIDE_NAVBAR, GET_TEMPLATE, GET_DATATYPE, GET_PURPOSE, GET_ENTITY, CONSENT_DATA_ARRAY,
    LOG_OUT, DASHBOARD_DATA, TEMPLATE_DETAIL, CONSENT_GROUP_ELEMENT_FROM_DASHBOARD, SCANNED_COOKIE_DATA, BULK_JSON_DATA, CREATE_BULK_CONSENT_RESPONSE, CONSENT_LIST, POST_COOKIES_SCAN_REPORT_RESPONSE, COOKIE_CONSENT_LOGS, COOKIE_SCAN_URL, COOKIE_DETAIL_WITH_DESCRIPTION, SCANNED_COOKIE_RESP, PROFILE_DATA, GET_PREFERENCE_CENTER_DATA, PRODUCT_THEME, GET_FAQ_DATA, GET_PRODUCT_THEME, CONSENT_DETAIL, SAVE_BLOCKCHAIN_AUTH_TOKEN, SAVE_AUTH_TOKEN, VERIFY_OTP_SUCCESS, CONSENT_VERIFICATION_RESULT, APP_NAME, APP_LOGO, ONBOARD_TEMPLATE, CONSENT_SESSION, CLEAR_SESSION, GET_CONSENT_GROUP_DATA, GET_CONSENTGROUPDATABY_GROUPID, GET_TEMPLATE_DETAIL_BY_TEMPLATEID, UPDATE_CONSENT_GROUP, GET_CREATE_CONSENT_GROUP_RESPONSE,GET_UPDATED_CONSENT_GROUP_RESPONSE, CONSENT_GROUP_ELEMENT, TEMPLATE_DETAIL_BY_SELECTED_CONSENTGROUP, UUID_TXN
} from "../actions/CommonAction";


const initialState = {

    homeTab: '1',
    tabIndex: '1',
    hideNavbar: true,
    otpTxnId: '',
    mobile: '',
    email: '',
    otpTxnIdForEmail: '',
    clientId: '',
    clientSecret: '',
    clientSecretForEmail: '',
    getTemplateList: [],
    getDatatypeList: [],
    getPurposeList: [],
    entityList: [],
    dashboarddata: '',
    clientIdForDashboard: '',
    getTemplateDetail: '',
    access_token: '',
    profileData: '',
    blockchain_access_token: '',
    scannedCookieData: '',
    scannedTransactionId: '',
    cookieDetailWithDescription: '',
    cookieScanURL: '',
    postCookieReportResponse: '',
    cookieConsentLogs: '',
    selectedBill: '',
    consentList: '',
    bulkData: '',
    bulkConsentResponse: '',
    verifyResult: '',
    App_Name: '',
    App_Logo: '',
    getOnboardResponse: '',
    sessionId: '',
    getConsentGroupData: '',
    getCreateConsentGroupResponse: '',
    getUpdateConsentGroupResponse: '',
    getConsentGroupDataByGroupId: '',
    getTemplateDetailDataByTemplateId: '',
    updateConsentGroup: '',
    selectedCGE: '',
    getConsentGroupDetailsByGroupId: '',
    templateBySelectedGroupData: '',
    uuid: '',
    receivedConsentGroup:''

}


const CommonReducer = (state = initialState, actions) => {

    switch (actions.type) {
        case SAVE_AUTH_TOKEN:
            return {
                ...state,
                access_token: actions.access_token
            }
        case SAVE_BLOCKCHAIN_AUTH_TOKEN:
            return {
                ...state,
                blockchain_access_token: actions.access_token
            }
        case SEND_OTP_SUCCESS:
            return {
                ...state,
                otpTxnId: actions.otpTxnId,
                mobile: actions.mobile,
                otpTxnIdForEmail: actions.otpTxnIdForEmail,
                email: actions.email,
                clientId: actions.clientId,
            }
        case VERIFY_OTP_SUCCESS:
            return {
                ...state,
                clientSecret: actions.clientSecret,
                clientSecretForEmail: actions.clientSecretForEmail
            }
        case UUID_TXN:
            return {
                ...state,
                uuid: actions.uuid
            }
        case CHANGE_HOMETAB:
            return {
                ...state,
                tabIndex: actions.tabIndex
            }
        case BILL_CHOICE:
            return {
                ...state,
                selectedBill: actions.selectedBill
            }
        case CONSENT_GROUP_ELEMENT:
            return {
                ...state,
                selectedCGE: actions.selectedCGE
            }
        case CONSENT_GROUP_ELEMENT_FROM_DASHBOARD:
            return{
                ...state,
                receivedConsentGroup: actions.receivedConsentGroup
            }
        case BULK_JSON_DATA:
            return {
                ...state,
                bulkData: actions.bulkData
            }
        case APP_NAME:
            return {
                ...state,
                App_Name: actions.appName
            }

        case CONSENT_SESSION:
            return {
                ...state,
                sessionId: actions.sessionId
            }

        case CLEAR_SESSION:
            return {
                ...state,
                sessionId: '',
            };

        case APP_LOGO:
            return {
                ...state,
                App_Logo: actions.Logo
            }
        case COOKIE_SCAN_URL:
            return {
                ...state,
                cookieScanURL: actions.changedUrl
            }
        case SCANNED_COOKIE_DATA:
            return {
                ...state,
                scannedCookieData: actions.resp
            }
        case SCANNED_COOKIE_RESP:
            return {
                ...state,
                scannedTransactionId: actions.resp.tranactionId
            }
        case COOKIE_DETAIL_WITH_DESCRIPTION:
            return {
                ...state,
                cookieDetailWithDescription: actions.resp.data
            }
        case POST_COOKIES_SCAN_REPORT_RESPONSE:
            return {
                ...state,
                postCookieReportResponse: actions.resp
            }
        case COOKIE_CONSENT_LOGS:
            return {
                ...state,
                cookieConsentLogs: actions.resp.data
            }
        case GET_TEMPLATE:
            return {
                ...state,
                getTemplateList: actions.getTemplateList
            }

        case TEMPLATE_DETAIL:
            return {
                ...state,
                getTemplateDetail: actions.getTemplateDetail
            }
        case CONSENT_DETAIL:
            return {
                ...state,
                getConsentDetail: actions.getConsentDetail,
                templateName: actions.templateName
            }
        case CONSENT_LIST:
            return {
                ...state,
                consentList: actions.consentList
            }
        case CREATE_BULK_CONSENT_RESPONSE:
            return {
                ...state,
                bulkConsentResponse: actions.resp
            }
        case ONBOARD_TEMPLATE:
            return {
                ...state,
                getOnboardResponse: actions.getOnboardResponse
            }

        case GET_CONSENTGROUPDATABY_GROUPID:
            return {
                ...state,
                getConsentGroupDetailsByGroupId: actions.templates
            }


        case GET_PURPOSE:
            return {
                ...state,
                getPurposeList: actions.getPurposeList
            }
        case GET_DATATYPE:
            return {
                ...state,
                getDatatypeList: actions.getDatatypeList
            }
        case GET_ENTITY:
            return {
                ...state,
                entityList: actions.entityList
            }
        case CONSENT_DATA_ARRAY:
            return {
                ...state,
                consentDataArrayValue: actions.data
            }
        case CONSENT_VERIFICATION_RESULT:
            return {
                ...state,
                verifyResult: actions.verifyResult,


            }
        case GET_PREFERENCE_CENTER_DATA:
            return {
                ...state,
                perferenceCenterData: actions.data
            }
        case PRODUCT_THEME:
            return {
                ...state,
                productTheme: actions.data
            }
        case GET_PRODUCT_THEME:
            return {
                ...state,
                getProductTheme: actions.data
            }
        case GET_FAQ_DATA:
            return {
                ...state,
                getFaqsData: actions.data
            }
        case GET_CONSENT_GROUP_DATA:
            return {
                ...state,
                getConsentGroupData: actions.data
            }

        case GET_CONSENTGROUPDATABY_GROUPID:
            return {
                ...state,
                getConsentGroupDataByGroupId: actions.data
            }
        case TEMPLATE_DETAIL_BY_SELECTED_CONSENTGROUP:
            return {
                ...state,
                templateBySelectedGroupData: actions.templates
            }
        case GET_TEMPLATE_DETAIL_BY_TEMPLATEID:
            return {
                ...state,
                getTemplateDetailDataByTemplateId: actions.data
            }

        case UPDATE_CONSENT_GROUP:
            return {
                ...state,
                updateConsentGroup: actions.data
            }

        case DASHBOARD_DATA:
            return {
                ...state,
                dashboarddata: actions.dashboarddata,
                clientIdForDashboard: actions.clientIdForDashboard
            }
        case PROFILE_DATA:
            return {
                ...state,
                profileData: actions.profileData,
                logo: actions.logo
            }
        case GET_CREATE_CONSENT_GROUP_RESPONSE:
            return {
                ...state,
                getCreateConsentGroupResponse: actions.getCreateConsentGroupResponse
            }

        case GET_UPDATED_CONSENT_GROUP_RESPONSE:
            return {
                ...state,
                getUpdateConsentGroupResponse: actions.getUpdateConsentGroupResponse
            }

        case APP_NAME:
            return {
                ...state,
                App_Name: actions.appName
            }

        case CONSENT_SESSION:
            return {
                ...state,
                sessionId: actions.sessionId
            }

        case CLEAR_SESSION:
            return {
                ...state,
                sessionId: '',
            };

        case APP_LOGO:
            return {
                ...state,
                App_Logo: actions.Logo
            }
        case LOG_OUT:
            return {
                ...state,
                proposalId: '',
                proposalTitle: '',
                homeTab: '1',
                tabIndex: '1',
                hideNavbar: true,
                otpTxnId: '',
                mobile: '',
                email: '',
                clientId: '',
                getTemplateList: [],
                getDatatypeList: [],
                getPurposeList: [],
                entityList: []
            }
        case HIDE_NAVBAR:
            return {
                ...state,
                hideNavbar: actions.status
            }

        default: return state;
    }

}

export default CommonReducer;